const DATE = {
  SMALL_DATE_FORMAT: 'ddd, MMM Do YYYY',
  TIME_FORMAT: 'HH:mm',
}

export default DATE
